// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2c1405ed","498":"400fa209","703":"8bb519a0","787":"abd9bb8e"}[chunkId] + ".chunk.js";
};